module.exports = __webpack_public_path__ + "img/图 63.ad22ab39.png";